import { useQuery } from '@apollo/client'
import { joinCourseDetailsQuery } from '../../../appsync/graphql/student'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentJoinCourseDetailsQuery = ({ otherSkipConditions = false }) => {
  const {
    loading,
    error: rawError = null,
    data: rawData = {},
  } = useQuery(joinCourseDetailsQuery, {
    skip: otherSkipConditions,
  })
  const data = rawData?.getJoinCourseDetails ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { data, loading, error }
}

export default useStudentJoinCourseDetailsQuery
